/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceDetailsFilter extends models.ServiceResourceBaseFilter {
    getFixupPrototypeFunction() { return ServiceResourceDetailsFilter.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceDetailsFilter>): ServiceResourceDetailsFilter {
        let obj = Object.assign(new ServiceResourceDetailsFilter(), model);
        ServiceResourceDetailsFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceDetailsFilter>): ServiceResourceDetailsFilter {
        if (!model) return null;
        return ServiceResourceDetailsFilter.newInstance(<ServiceResourceDetailsFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceDetailsFilter) {
        if (!obj) return;

        models.ServiceResourceDetailsFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceDetailsFilter): boolean {
        if (models.ServiceResourceBaseFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceResourceDetailsFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Filter by one or more resources
     */
    resources: Array<string>;

}
